<template>
  <div id="calculation-footer-spacer">
    <div id="in-calc-footer" class="influenced-by-modal">
      <div class="in-calc-footer-content limiter-1280">
        <div 
          id="total-cost" 
          class="toogle-calculation-results-overlay">
          <div class="sum">
            <span class="sum-description">{{$t('calculation_footer.total')}} <span class="umst-text">({{$t('calculation_footer.net')}})</span>:</span>
            <span 
              v-show="!loading"
              class="sum-number">{{ calculation.total | numberFormater }} EUR</span>
            <span 
              v-show="loading"
              class="sum-loader" 
            ><div class="line-scale"><div/><div/><div/><div/><div/></div></span>
          </div>
          <div class="open-close-btn no-select">
            <i class="fa fa-angle-up"/>
          </div>
          <div class="detailed-cost animated fadeIn">
            <a 
              id="dc-close" 
              href="#"
              class="close-icon toogle-calculation-results-overlay"/>
            <div class="dc-content">
              <div class="dc-headline">{{ $t('calculation_footer.cost_overview') }}</div>
              <div>
                <div 
                  id="dc-details" 
                  class="dc-details">
                  <div>
                    <div 
                      v-for="result in calculation.results"
                      :key="result.id"
                      class="row">
                      <div class="col-xs-7 dc-detail-result">
                        <i class="fa fa-circle" />
                        <span 
                          class="dc-detail-label" 
                          v-text="result.label" />
                      </div>
                      <div class="col-xs-5 dc-detail-price"><span class="result-wrapper">{{ result.calculated | numberFormater }} EUR</span>
                      </div>
                    </div>
                    <div  
                      v-for="result in calculation.customResults" 
                      :key="result.id"
                      class="row">
                      <div class="col-xs-7 dc-detail-result">
                        <i class="fa fa-circle"/>
                        <span 
                          class="dc-detail-label" 
                          v-text="result.label"/>
                      </div>
                      <div class="col-xs-5 dc-detail-price"><span class="result-wrapper">{{ result.calculated | numberFormater }} EUR</span>
                      </div>
                    </div>
                    <div 
                      v-show="calculation.surcharges && calculation.surcharges.length" 
                      class="dc-divider"/>
                    <div 
                      v-show="calculation.surcharges && calculation.surcharges.length" 
                      class="dc-subtotal row">
                      <div class="col-xs-7 dc-subtotal-title"><span>{{ $t('calculation_footer.subtotal') }}</span></div>
                      <div class="col-xs-5 dc-subtotal-sum"><span>{{ calculation.subtotal | numberFormater }} EUR</span>
                      </div>
                    </div>
                    <div 
                      v-for="result in calculation.surcharges" 
                      :key="result.id"
                      class="row">
                      <div class="col-xs-7 dc-detail-result">
                        <i class="fa fa-circle"/>
                        <span class="dc-detail-label">{{ result.label }}</span>
                      </div>
                      <div class="col-xs-5 dc-detail-price">
                        <span class="result-wrapper">{{ result.calculated | numberFormater }} EUR</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="in-calc-nav row">
          <div 
            class="col-xs-3 row in-calc-nav-item open-modal" 
            @click.prevent="calculationOverviewModal">
            <div class="col-xs-12 col-md-6 col-lg-4 icon-box-footer-wrapper">
              <div class="icon-box-footer">
                <i class="fa fa-align-left"/>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 col-lg-8 in-calc-link-wrapper">
              <span>{{ $t('calculation_footer.show_overview') }}</span>
            </div>
          </div>
          <div 
            :class="{'missing-eventname': !$store.isCalculationSaved, 'green-background': $store.isCalculationSaved}"
            class="col-xs-3 row in-calc-nav-item"
            @click.prevent="changeCalculationName">
            <div class="col-xs-12 col-md-6 col-lg-4 icon-box-footer-wrapper">
              <div class="icon-box-footer">
                <i class="icon-memory"/>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 col-lg-8 in-calc-link-wrapper">
              <span v-text="saveCalculationLabel"></span>
            </div>
          </div>
          <div 
            class="col-xs-3 row in-calc-nav-item" 
            @click.prevent="requestConsultation">
            <div class="col-xs-12 col-md- col-lg-4 icon-box-footer-wrapper">
              <div class="icon-box-footer">
                <i class="icon-beratung"/>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 col-lg-8 in-calc-link-wrapper">
              <span>{{ $t('calculation_footer.request_advice') }}</span>
            </div>
          </div>
          <div 
            class="col-xs-3 row in-calc-nav-item" 
            @click.prevent="requestOffer">
            <div class="col-xs-12 col-md-6 col-lg-4 icon-box-footer-wrapper">
              <div class="icon-box-footer">
                <i class="icon-angebot"/>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 col-lg-8 in-calc-link-wrapper">
              <span>{{ $t('calculation_footer.request_a_quote') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import {checkInCalcFooterOffset, breakpoint} from "../utility"

    export default {
        name: 'CalculationFooter',
        props: {
            calculation: {
                type: Object,
                required: true
            },
            recalculating: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                loading: false
            }
        },
        computed: {
            saveCalculationLabel() {
                if(!this.$store.isCalculationSaved) {
                    return this.$t('calculation_footer.save_calculation')
                }

                return this.$t('calculation_footer.calculation_saved')
            }
        },
        created() {
            this.$event.$on('start-recalculation', () => {
                this.loading = true
            })

            this.$event.$on('new-data', () => {
                this.loading = false
                this.$nextTick(() => {
                  checkInCalcFooterOffset()
                })
            })
        },
        mounted() {
            //scroll Event
            $(document).scroll(function () {
                checkInCalcFooterOffset()
            })

            //Resize event
            $(window).resize(function () {
                breakpoint.refreshValue()
                checkInCalcFooterOffset()
            }).resize()

            $('.toogle-calculation-results-overlay').on('click', function (event) {
                event.stopPropagation()
                event.preventDefault()

                let $openCloseBtn = $('.open-close-btn'),
                    $detailedCost = $('.detailed-cost')

                if (!$openCloseBtn.hasClass('is-active')) {
                    $openCloseBtn.addClass('is-active')
                    $('i', $openCloseBtn).removeClass('fa-angle-up').addClass('fa-angle-down')
                    $detailedCost.show()
                } else {
                    $openCloseBtn.removeClass('is-active')
                    $('i', $openCloseBtn).addClass('fa-angle-up').removeClass('fa-angle-down')
                    $detailedCost.hide()
                }
            })

            $(document).on('click', function () {
                let $openCloseBtn = $('.open-close-btn'),
                    $detailedCost = $('.detailed-cost')

                $openCloseBtn.removeClass('is-active')
                $('i', $openCloseBtn).addClass('fa-angle-up').removeClass('fa-angle-down')
                $detailedCost.hide()
            })

            //autocall request-offer
            if(this.$cookie.get('autocall-request-offer') === '1') {
              this.$cookie.delete('autocall-request-offer')
              this.requestOffer()
            }

            this.$nextTick(function () {
                checkInCalcFooterOffset()
            })
        },
        methods: {
            changeCalculationName() {
                this.$event.$emit('change-calculation-name')
            },
            calculationOverviewModal() {
                this.$event.$emit('show-calculation-overview-modal', this.$store.calculation)
            },
            requestConsultation() {
                this.$event.$emit('call-contact-modal', {scope: "request-consultation"})
            },
            requestOffer() {
                if (!window.AuthCheck) {
                    this.$event.$emit('login-first', 'autocall-request-offer')
                    
                    return
                }

                if (!this.$store.isCalculationSaved) {
                    this.$event.$emit('change-calculation-name', {
                      text:  this.$t('calculation_footer.save_first'),
                      autocall: this.requestOffer
                    })

                    return
                }

                this.$event.$emit('call-contact-modal', {scope: "request-offer"})
            }
        }
    }
</script>